import React, { createContext, useEffect, useReducer } from "react"
import { Helmet } from "react-helmet"
import languageReducer from './languageReducer'
import cookie from 'react-cookies'

import fr from '../../utils/i18n/fr.json'
import en from '../../utils/i18n/en.json'
import { SET_CURRENT_LANGUAGE } from "../types"

const WECAR_LANGUAGE_COOKIE = "wecar_lang"

export const LanguageContext = createContext()

const source = {
  fr,
  en,
}

const DEFAULT_LANGUAGE = "fr"

const LanguageState = ({children}) => {

  const initialState = {
    currentLanguage: DEFAULT_LANGUAGE // cookie.load(WECAR_LANGUAGE_COOKIE) || DEFAULT_LANGUAGE
  }

  useEffect(() => {
    const browserLanguage = "" // window.navigator.language.split('-')[0]
    const cookieLanguage = "" // cookie.load(WECAR_LANGUAGE_COOKIE)
    const validLanguages = Object.keys(source)

    if(!cookieLanguage) {
      if(validLanguages.includes(browserLanguage)) {
        setLanguage(browserLanguage)
      } else {
        setLanguage(DEFAULT_LANGUAGE)
      }
    } else {
      if(validLanguages.includes(cookieLanguage)) {
        setLanguage(cookieLanguage)
      } else {
        setLanguage(DEFAULT_LANGUAGE)
      }
    }
  }, [])

  const [state, dispatch] = useReducer(languageReducer, initialState);

  const setLanguage = (lang) => {
    
    cookie.save(WECAR_LANGUAGE_COOKIE, lang)

    dispatch({
      type: SET_CURRENT_LANGUAGE,
      payload: lang
    })
  }

  const t = (key, params, forcedLanguage, defaultValue) => {
    const language = forcedLanguage || state.currentLanguage
    const components = key.split('.')
    if(!source[language]) {
      // if(!defaultValue) 
      //   throw new Error(`Language ${language} not supported`)
      return defaultValue ?? key
    }
    const section = source[language][components[0]]
    if(!section) {
      // if(!defaultValue)
      //   throw new Error(`Section ${key} not found in ${language} language`)
      return defaultValue ?? key
    }
    let value = section[components[1]]
    if(!value) {
      // if(!defaultValue)
      //   throw new Error(`Key ${key} not found in ${language} language`)
      return defaultValue ?? key
    }
    if(params) {
      for(let p in params) {
        value = value.replace(`{{${p}}}`, params[p])
      }
    }
    return value
  }

  return <LanguageContext.Provider value={{
    currentLanguage: state.currentLanguage,
    setLanguage,
    t
  }}>
    <>
      <Helmet>
        <title>{t('meta.title')}</title>
        <meta name="description" content={t('meta.description')} />

        <meta property="og:title" content={t('meta.title')} />
        <meta property="og:description" content={t('meta.description')} />

        <meta name="twitter:title" content={t('meta.title')} />
        <meta name="twitter:description" content="{t('meta.description')}" />
      </Helmet>
      {children}
    </>
  </LanguageContext.Provider>
}

export default LanguageState